export default "__VITE_ASSET__CNnYSFbv__"